import React from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Link from "@amzn/meridian/link";
import { HeadSection } from "../..";
import Content from "./content";
import BulletPoints from "./bulletPoints";
import { useNavigate } from "react-router";
import { HOME, MY_HR, A_TO_Z, openInNewTab } from "../..";
import { useBundle } from "@amzn/react-arb-tools";
import { POLICYPAGE_MESSAGE_BUNDLE_NAME } from "src/constants";
import { t } from "src/helpers";

const Policy = ({ Footer, footerWidths, widths, headerTextType }) => {
  const [bundle] = useBundle(POLICYPAGE_MESSAGE_BUNDLE_NAME);
  const navigate = useNavigate();

  return (
    <Column
      spacing="500"
      height="101%"
      heights={["150px", "fill", "1em", "100px"]}
    >
      <HeadSection
        alignmentHorizontal = "start"
        type={headerTextType ?? "h600"}
        widths={widths ?? ["grid-2", "grid-8"]}
      >
        {t(bundle, "policy_header")}
      </HeadSection>
      <Row
        alignmentVertical="top"
        widths={widths ? widths : ["grid-2", "grid-8"]}
      >
        <Column></Column>
        <Column>
          <Content
            heading={t(bundle, "purpose_header")}
            paragraph={t(bundle, "purpose_paragraph")}
          ></Content>
          <Content
            heading={t(bundle, "applicability_header")}
            paragraph={t(bundle, "applicability_paragraph")}
          ></Content>
          <Content
            heading={t(bundle, "eligibility_header")}
            paragraph={t(bundle, "eligibility_paragraph")}
          ></Content>
          <Column spacing={"400"}>
            <Column spacing={"100"}>
              <Text type="h200">{t(bundle, "overview_header")}</Text>
              <Text type="b200">
                {t(bundle, "overview_paragraph_first")}{" "}
                <Link onClick={() => navigate(HOME)}>
                  {t(bundle, "using_the_link_here")}
                </Link>{" "}
              </Text>
            </Column>
            <Text type="b200">{t(bundle, "overview_paragraph_second")}</Text>
            <Text type="b200">{t(bundle, "overview_paragraph_third")}</Text>
          </Column>
          <BulletPoints
            heading={t(bundle, "overview_paragraph_fourth")}
            paragraph={["overview_paragraph_fifth", "overview_paragraph_sixth"]}
          ></BulletPoints>
          <BulletPoints
            heading={t(bundle, "overview_paragraph_seventh")}
            paragraph={["overview_paragraph_eigth", "overview_paragraph_ninth"]}
          ></BulletPoints>
          <Text type="b200">{t(bundle, "overview_paragraph_tenth")}</Text>
          <Column spacing={"100"}>
            <Text type="h200">
              {t(bundle, "amazon_does_not_permit_header")}
            </Text>
            <BulletPoints
              heading={t(bundle, "amazon_does_not_permit_first")}
              paragraph={[
                "amazon_does_not_permit_second",
                "amazon_does_not_permit_third",
                "amazon_does_not_permit_fourth",
                "amazon_does_not_permit_fifth",
                "amazon_does_not_permit_sixth",
                "amazon_does_not_permit_seventh",
              ]}
            ></BulletPoints>
          </Column>
          <Column spacing={"300"}>
            <Column spacing={"100"}>
              <Text type="h200">{t(bundle, "additional_support_header")}</Text>
              <Text type="b200">{t(bundle, "additional_support_first")}</Text>
            </Column>
            <Text type="b200">
              {t(bundle, "additional_support_second")}{" "}
              <Link onClick={() => openInNewTab(MY_HR)}>
                {t(bundle, "myhr")}
              </Link>{" "}
              {t(bundle, "or")}{" "}
              <Link onClick={() => openInNewTab(A_TO_Z)}>
                {t(bundle, "atoz")}
              </Link>{" "}
              {t(bundle, "learn_about_the_process")}
            </Text>
            <Text type="b200">{t(bundle, "additional_support_third")}</Text>
          </Column>
        </Column>
      </Row>
      <Row></Row>
      <Footer widths={footerWidths}></Footer>
    </Column>
  );
};

export default Policy;
